module.exports = {"pathContext":{"name":"ChangelogOrderBy","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"insertedAt","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-changelog-order-by.json
// module id = 1380
// module chunks = 21810443222662